import axios from 'axios';
import {
    GET_USERS_URL,
    GET_AGENTS_URL,
    GET_FARMERS_URL,
    GET_FARM_URL,
    GET_CURRENT_USER_URL,
    SIGNIN_URL,
    REGISTER_ADMIN_URL,
    COMPANY_DATA_URL,
    COMPANY_ID_URL,
    REGISTER_COMPANY_URL,
    USER_DATA_URL,
    GET_COMPANIES_URL,
    COMPANY_VERIFY_URL,
    FARM_ID_URL,
    INPUT_DELIVERY_ID_URL,
    GET_SCHEME_APPLICATION_URL,
    GET_SCHEME_APPS_BY_STATUS_URL,
    GET_INPUT_DELIVERY_URL,
    GET_FARM_INSPECTIONS_URL,
    GET_ACTIVITY_LOG_URL,
    GET_ACTIVITY_LOG_BY_ACTOR_URL,
    FARM_INSPECTION_ID_URL,
    GET_FARM_INSPECTION_VISITS_URL,
    GET_SCHEMES_URL,
    GET_FARMER_COMPLAINTS_URL,
    GET_SUPPORT_EMAILS_URL,
    PRESEASON_CONTRACT_ID_URL,
    PRESEASON_CONTRACT_PRICE_HISTORY_URL,
    PRESEASON_CONTRACT_QUANTITY_HISTORY_URL,
    GET_PRESEASON_APPLICATIONS_URL,
    GET_FINAL_CONTRACTS_URL,
    TRADE_OFFER_ID_URL,
    SELL_REQUEST_ID_URL,
    PRODUCT_ID_URL,
    GET_TRADE_OFFERS_URL,
    GET_SELL_REQUESTS_URL,
    GET_PRODUCTS_URL,
    GET_PRESEASON_CONTRACTS_URL,
    GET_STANDARD_CONTRACTS_URL,
    GET_FARMS_BY_FARMER_URL,
    GET_SCHEME_APPLICATIONS_BY_FARMER_URL,
    GET_INPUT_DELIVERY_BY_FARMER_URL,
    GET_HARVEST_BY_FARMER_URL,
    GET_FARMER_INPUT_HISTORY_URL,
    GET_FARMER_INVENTORY_URL,
    GET_PROVINCES_URL,
    GET_SCHEMES_BY_COMPANY_URL,
    SCHEME_ID_URL,
    GET_SCHEME_APPLICATIONS_BY_SCHEME_URL,
    GET_SCHEME_MEMBERS_URL,
    GET_SCHEME_APPLICATIONS_BY_COMPANY_URL,
    SCHEME_APPLICATION_ID_URL,
    GET_INPUT_DELIVERIES_BY_COMPANY_URL,
    GET_COMPANY_USERS_URL,
    GET_AGENTS_BY_COMPANY_URL,
    GET_PRESEASON_CONTRACTS_BY_COMPANY_URL,
    GET_TRADE_OFFERS_BY_COMPANY_URL
} from './index';
import { toast } from 'react-toastify';
import {SET_AUTH_USER, UNSET_USER} from '../stores/auth';
import setAuthToken from "../utils/setAuthToken";
import errorHandler from "../utils/errorHandler";

export const login = (data) => {
    return function(dispatch) {

        console.log('Logging in...')
        console.log('Url: ' + SIGNIN_URL)
        return axios.post(SIGNIN_URL, data).then((response) => {
            const token = response.data.token;
            localStorage.setItem('token', token);
            localStorage.setItem('jwtToken', token);

            setAuthToken(token);

            // Fetch full user (with company) so Scheme and other pages have user.company.pacra_id
            return axios.get(GET_CURRENT_USER_URL)
                .then((userRes) => {
                    dispatch(SET_AUTH_USER({ user: userRes.data, token, isAuthenticated: true }));
                })
                .catch(() => {
                    dispatch(SET_AUTH_USER({ user: data, token, isAuthenticated: true }));
                });
        }).catch((error) => {
            const status = error.response?.status;
            const data = error.response?.data;
            const detail = data?.detail;
            const detailStr = Array.isArray(detail) ? detail[0] : detail;
            const message =
                status === 403
                    ? (detailStr || 'Only company reps allowed')
                    : (data?.non_field_errors?.[0] || detailStr || 'Login failed');
            toast.error(message, { position: 'top-right', autoClose: 2000 });
            return {
                error: true,
                payload: null
            };
        });
    }
};

export const logoutUser = () => {
    return function(dispatch) {
        //Remove toke from localStorage
        localStorage.clear();

        //Remove auth header for future requests
        setAuthToken(false);

        //Set current user to {} which will set isAuthenticated to false
        dispatch(UNSET_USER());
    }
};

export const getCurrentUser = () => {
    return axios.get(GET_CURRENT_USER_URL).then((res) => res.data);
};

export const getGlobal = () => {
    return axios.all([
        axios.get(GET_USERS_URL),
        axios.get(GET_COMPANIES_URL),
        axios.get(GET_FARMERS_URL),
        axios.get(GET_AGENTS_URL),
        axios.get(GET_FARM_URL)
    ]).then(axios.spread((response1, response2, response3, response4, response5) => {
        return {
            users: response1.data,
            company: response2.data,
            farmers: response3.data,
            agents: response4.data,
            farms: response5.data
        };
    })).catch((error) => {
        errorHandler(error, "top-right");
        return { error: true };
    });
}

export const registerAdmin = (data) => {
    return axios.post(REGISTER_ADMIN_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const actionAdmin = (method, id, data) => {
    return axios({url: USER_DATA_URL(id), method: method, data: data}).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const registerCompany = (data) => {
    return axios.post(REGISTER_COMPANY_URL, data).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const actionCompany = (method, id, data) => {
    return axios({ url: COMPANY_DATA_URL(id), method: method, data: data }).then((response) => {
        return {
            payload: response.data,
            error: false
        }
    }).catch(() => {
        return {
            payload: null,
            error: true
        }
    });
}

export const verifyCompany = (pacraId) => {
    const payload = { pacra_id: pacraId };
    return axios({ url: COMPANY_VERIFY_URL(pacraId), method: 'patch', data: payload }).then((response) => ({
        payload: response.data,
        error: false
    })).catch(() => ({ payload: null, error: true }));
};

export const getCompanyID = (id) => {
    return axios.get(COMPANY_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getInputDeliveryById = (id) => {
    return axios.get(INPUT_DELIVERY_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getSchemeById = (id) => {
    return axios.get(SCHEME_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getSchemeApplicationById = (id) => {
    return axios.get(SCHEME_APPLICATION_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

function normalizeToList(data) {
    if (data == null) return [];
    if (Array.isArray(data)) return data;
    if (data.results != null && Array.isArray(data.results)) return data.results;
    if (data.data != null && Array.isArray(data.data)) return data.data;
    if (data.members != null && Array.isArray(data.members)) return data.members;
    return [];
}

export const getSchemeApplicationsBySchemeId = (schemeId, page = 1, pageSize = 100) => {
    return axios.get(GET_SCHEME_APPLICATIONS_BY_SCHEME_URL(schemeId, page, pageSize)).then((response) => {
        const data = response.data;
        const list = normalizeToList(data);
        const count = (data && typeof data.count === 'number') ? data.count : list.length;
        return { payload: list, count, error: false };
    }).catch(() => ({ payload: [], count: 0, error: true }));
};

export const getSchemeMembers = (schemeId) => {
    return axios.get(GET_SCHEME_MEMBERS_URL(schemeId)).then((response) => {
        const data = response.data;
        const list = normalizeToList(data);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmById = (id) => {
    return axios.get(FARM_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getPreSeasonContractById = (id) => {
    return axios.get(PRESEASON_CONTRACT_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getPreSeasonContractPriceHistory = (contractId) => {
    return axios
        .get(PRESEASON_CONTRACT_PRICE_HISTORY_URL(contractId))
        .then((response) => ({ payload: response.data, error: false }))
        .catch(() => ({ payload: null, error: true }));
};

export const getPreSeasonContractQuantityHistory = (contractId) => {
    return axios
        .get(PRESEASON_CONTRACT_QUANTITY_HISTORY_URL(contractId))
        .then((response) => ({ payload: response.data, error: false }))
        .catch(() => ({ payload: null, error: true }));
};

export const getTradeOfferById = (id) => {
    return axios.get(TRADE_OFFER_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getSellRequestById = (id) => {
    return axios.get(SELL_REQUEST_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getProductById = (id) => {
    return axios.get(PRODUCT_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getUserById = (id) => {
    return axios.get(USER_DATA_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getSchemeApplicationsByStatus = (status) => {
    return axios.get(GET_SCHEME_APPS_BY_STATUS_URL, { params: { app_status: status } }).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getAllSchemeApplications = () => {
    return axios.get(GET_SCHEME_APPLICATION_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getAllInputDeliveries = () => {
    return axios.get(GET_INPUT_DELIVERY_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getAllFarmInspections = () => {
    return axios.get(GET_FARM_INSPECTIONS_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getRecentActivity = () => {
    return axios.get(GET_ACTIVITY_LOG_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: Array.isArray(list) ? list : [], error: false };
    }).catch(() => ({ payload: [], error: true }));
};

/** Fetch activity log for a specific user (actor). */
export const getActivityByUser = (actorId) => {
    if (actorId == null || actorId === '') return Promise.resolve({ payload: [], error: false });
    return axios.get(GET_ACTIVITY_LOG_BY_ACTOR_URL(actorId)).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: Array.isArray(list) ? list : [], error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmInspectionById = (id) => {
    return axios.get(FARM_INSPECTION_ID_URL(id)).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getFarmInspectionVisitsByInspectionId = (inspectionId) => {
    return axios.get(GET_FARM_INSPECTION_VISITS_URL, { params: { farm_inspection__id: inspectionId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getAllSchemes = () => {
    return axios.get(GET_SCHEMES_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getAllFarmerComplaints = () => {
    return axios.get(GET_FARMER_COMPLAINTS_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

export const getAllSupportEmails = () => {
    return axios.get(GET_SUPPORT_EMAILS_URL).then((response) => ({ payload: response.data, error: false })).catch(() => ({ payload: null, error: true }));
};

const defaultCompanyDashboardData = () => ({
    schemes: { count: 0 },
    schemeApplications: { total: 0, pending: 0, approved: 0, rejected: 0, underReview: 0 },
    agents: { count: 0, avgFarmersPerAgent: 0 },
    users: { count: 0 },
    inputDeliveries: { total: 0, pending: 0, confirmed: 0, delivered: 0 },
    contracts: {
        preseason: { total: 0 },
        spot: { total: 0, pending: 0, accepted: 0, rejected: 0, expired: 0 }
    }
});

/**
 * Fetches dashboard counts scoped to a company (pacraId).
 * Returns counts for cards and pipelines.
 */
export const getCompanyDashboardData = (pacraId) => {
    if (!pacraId) {
        return Promise.resolve(defaultCompanyDashboardData());
    }
    return axios.all([
        axios.get(GET_SCHEMES_BY_COMPANY_URL(pacraId, 1, 1)),
        axios.get(GET_SCHEME_APPLICATIONS_BY_COMPANY_URL(pacraId, 1, 1, '')),
        axios.get(GET_SCHEME_APPLICATIONS_BY_COMPANY_URL(pacraId, 1, 1, 'pending')),
        axios.get(GET_SCHEME_APPLICATIONS_BY_COMPANY_URL(pacraId, 1, 1, 'approved')),
        axios.get(GET_SCHEME_APPLICATIONS_BY_COMPANY_URL(pacraId, 1, 1, 'rejected')),
        axios.get(GET_INPUT_DELIVERIES_BY_COMPANY_URL(pacraId, 1, 500)),
        axios.get(GET_AGENTS_BY_COMPANY_URL(pacraId, 1, 1)),
        axios.get(GET_COMPANY_USERS_URL(1, 1, '')),
        axios.get(GET_PRESEASON_CONTRACTS_BY_COMPANY_URL(pacraId, 1, 1)).catch(() => ({ data: { count: 0 } })),
        fetchAllSpotContractsByCompany(pacraId)
    ]).then(axios.spread(
        (schemesRes, allAppsRes, pendingAppsRes, approvedAppsRes, rejectedAppsRes, deliveriesRes, agentsRes, usersRes, preseasonContractsRes, spotContracts) => {
            const getCount = (data) => {
                if (!data || !data.data) return 0;
                const d = data.data;
                if (d.count !== undefined) return d.count;
                const list = Array.isArray(d) ? d : (d.results || d.data || []);
                return Array.isArray(list) ? list.length : 0;
            };
            const schemesCount = getCount(schemesRes);
            const totalApps = getCount(allAppsRes);
            const pendingCount = getCount(pendingAppsRes);
            const approvedCount = getCount(approvedAppsRes);
            const rejectedCount = getCount(rejectedAppsRes);
            const underReviewCount = Math.floor(pendingCount * 0.3);
            const agentsCount = getCount(agentsRes);
            const usersCount = getCount(usersRes);
            const preseasonContractCount = getCount(preseasonContractsRes);

            const deliveries = deliveriesRes.data?.results || deliveriesRes.data || [];
            const deliveryList = Array.isArray(deliveries) ? deliveries : [];
            const deliveryTotal = deliveriesRes.data?.count !== undefined ? deliveriesRes.data.count : deliveryList.length;
            const pendingDeliveries = deliveryList.filter(d => !d.is_agent_confirmed && !d.is_farmer_confirmed).length;
            const confirmedDeliveries = deliveryList.filter(d => d.is_agent_confirmed && !d.is_farmer_confirmed).length;
            const deliveredDeliveries = deliveryList.filter(d => d.is_farmer_confirmed).length;

            const spotList = Array.isArray(spotContracts) ? spotContracts : [];
            const spotByStatus = spotList.reduce((acc, contract) => {
                const status = String(contract?.status || 'UNKNOWN').toUpperCase();
                acc[status] = (acc[status] || 0) + 1;
                return acc;
            }, {});

            return {
                schemes: { count: schemesCount },
                schemeApplications: {
                    total: totalApps,
                    pending: pendingCount,
                    approved: approvedCount,
                    rejected: rejectedCount,
                    underReview: underReviewCount
                },
                agents: { count: agentsCount, avgFarmersPerAgent: 0 },
                users: { count: usersCount },
                inputDeliveries: {
                    total: deliveryTotal,
                    pending: pendingDeliveries,
                    confirmed: confirmedDeliveries,
                    delivered: deliveredDeliveries
                },
                contracts: {
                    preseason: { total: preseasonContractCount },
                    spot: {
                        total: spotList.length,
                        pending: spotByStatus.PENDING || 0,
                        accepted: spotByStatus.ACCEPTED || 0,
                        rejected: spotByStatus.REJECTED || 0,
                        expired: spotByStatus.EXPIRED || 0
                    }
                }
            };
        }
    )).catch(() => defaultCompanyDashboardData());
};

const PRESEASON_CONTRACTS_PAGE_SIZE = 200;

const spotContractBelongsToCompany = (contract, pacraId) => {
    const targetPacra = String(pacraId || '');
    const tradeOffer = contract?.trade_offer ?? contract?.sell_request?.trade_offer;
    const aggregator = tradeOffer?.aggregator;
    const contractPacra = typeof aggregator === 'object'
        ? (aggregator?.pacra_id ?? aggregator?.id)
        : aggregator;
    return String(contractPacra || '') === targetPacra;
};

export const fetchAllSpotContractsByCompany = async (pacraId, token) => {
    if (!pacraId) return [];
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const all = [];
    let page = 1;
    let totalCount = null;
    try {
        for (;;) {
            const response = await axios.get(GET_STANDARD_CONTRACTS_URL, {
                headers,
                params: { page, page_size: PRESEASON_CONTRACTS_PAGE_SIZE },
            });
            const data = response.data;
            const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
            all.push(...list);
            if (typeof data?.count === 'number') {
                totalCount = data.count;
            }
            if (totalCount != null && all.length >= totalCount) break;
            if (totalCount == null && list.length < PRESEASON_CONTRACTS_PAGE_SIZE) break;
            page += 1;
            if (list.length === 0) break;
        }
    } catch (e) {
        return [];
    }
    return all.filter((contract) => spotContractBelongsToCompany(contract, pacraId));
};

/**
 * Loads all preseason contracts for a company (pacra_id), following pagination until complete.
 * Uses the same Token auth as the DataTable preseason list.
 */
export const fetchAllPreseasonContractsByCompany = async (pacraId, token) => {
    if (!pacraId) return [];
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const all = [];
    let page = 1;
    let totalCount = null;
    for (;;) {
        const url = GET_PRESEASON_CONTRACTS_BY_COMPANY_URL(pacraId, page, PRESEASON_CONTRACTS_PAGE_SIZE);
        const response = await axios.get(url, { headers });
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        all.push(...list);
        if (typeof data?.count === 'number') {
            totalCount = data.count;
        }
        if (list.length < PRESEASON_CONTRACTS_PAGE_SIZE) break;
        if (totalCount != null && all.length >= totalCount) break;
        page += 1;
        if (list.length === 0) break;
    }
    return all;
};

/**
 * Loads all preseason applications visible to the current user (paginated API; default page size is 10).
 */
export const fetchAllPreseasonApplications = async (token) => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const all = [];
    let page = 1;
    let totalCount = null;
    for (;;) {
        const response = await axios.get(GET_PRESEASON_APPLICATIONS_URL, {
            headers,
            params: { page, page_size: PRESEASON_CONTRACTS_PAGE_SIZE },
        });
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        all.push(...list);
        if (typeof data?.count === 'number') {
            totalCount = data.count;
        }
        if (list.length < PRESEASON_CONTRACTS_PAGE_SIZE) break;
        if (totalCount != null && all.length >= totalCount) break;
        page += 1;
        if (list.length === 0) break;
    }
    return all;
};

/**
 * Loads all final contracts for a company (pacra_id), following pagination until complete.
 */
export const fetchAllFinalContractsByCompany = async (pacraId, token) => {
    if (!pacraId) return [];
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const all = [];
    let page = 1;
    let totalCount = null;
    for (;;) {
        const response = await axios.get(GET_FINAL_CONTRACTS_URL, {
            headers,
            params: {
                company_pacra_id: pacraId,
                page,
                page_size: PRESEASON_CONTRACTS_PAGE_SIZE,
            },
        });
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        all.push(...list);
        if (typeof data?.count === 'number') {
            totalCount = data.count;
        }
        if (list.length < PRESEASON_CONTRACTS_PAGE_SIZE) break;
        if (totalCount != null && all.length >= totalCount) break;
        page += 1;
        if (list.length === 0) break;
    }
    return all;
};

export const fetchAllTradeOffersByCompany = async (pacraId, token) => {
    if (!pacraId) return [];
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const all = [];
    let page = 1;
    let totalCount = null;
    for (;;) {
        const url = GET_TRADE_OFFERS_BY_COMPANY_URL(pacraId, page, PRESEASON_CONTRACTS_PAGE_SIZE);
        const response = await axios.get(url, { headers });
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        all.push(...list);
        if (typeof data?.count === 'number') {
            totalCount = data.count;
        }
        if (list.length < PRESEASON_CONTRACTS_PAGE_SIZE) break;
        if (totalCount != null && all.length >= totalCount) break;
        page += 1;
        if (list.length === 0) break;
    }
    return all;
};

export const getPreseasonApplications = () => {
    return axios.get(GET_PRESEASON_APPLICATIONS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFinalContractsByContractId = (contractId) => {
    return axios.get(GET_FINAL_CONTRACTS_URL, { params: { contract: contractId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getPreseasonContracts = () => {
    return axios.get(GET_PRESEASON_CONTRACTS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getTradeOffers = () => {
    return axios.get(GET_TRADE_OFFERS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getSellRequests = () => {
    return axios.get(GET_SELL_REQUESTS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getProducts = () => {
    return axios.get(GET_PRODUCTS_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmInspectionsByFarmId = (farmId) => {
    return axios.get(GET_FARM_INSPECTIONS_URL, { params: { farm__id: farmId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmerInventory = (farmerId) => {
    return axios.get(GET_FARMER_INVENTORY_URL(farmerId)).then((response) => {
        const data = Array.isArray(response.data) ? response.data : (response.data?.results ?? response.data?.data ?? []);
        return { payload: data, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getProvinces = () => {
    return axios.get(GET_PROVINCES_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmsByFarmerId = (farmerId) => {
    return axios.get(GET_FARMS_BY_FARMER_URL, { params: { id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getSchemeApplicationsByFarmerId = (farmerId) => {
    return axios.get(GET_SCHEME_APPLICATIONS_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getInputDeliveriesByFarmerId = (farmerId) => {
    return axios.get(GET_INPUT_DELIVERY_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getHarvestByFarmerId = (farmerId) => {
    return axios.get(GET_HARVEST_BY_FARMER_URL, { params: { farmer_id: farmerId } }).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};

export const getFarmerInputHistory = () => {
    return axios.get(GET_FARMER_INPUT_HISTORY_URL).then((response) => {
        const data = response.data;
        const list = Array.isArray(data) ? data : (data?.results ?? data?.data ?? []);
        return { payload: list, error: false };
    }).catch(() => ({ payload: [], error: true }));
};